exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#app__loader{position:fixed;top:0;left:0;width:100vw;height:100vh;z-index:1;background:rgba(0,0,0,.5) url(/src/assets/imgs/loading.gif) 50%/45px 45px no-repeat;cursor:wait}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 601
// module chunks = 0